export enum FaFontWeight {
  THIN = 'fat',
  LIGHT = 'fal',
  REGULAR = 'far',
  SOLID = 'fas'
}
